module.exports = __webpack_public_path__ + "img/20210730_122501.a8c5b1bd.jpg";